
import './AddProfileContainer.scss';
export default function AddProfileContainer(props: any) {
    return (
        <div className="sc-eKZiaR jlEkHf ">
            <section data-testid="profiles-wrapper" className="sc-drMfKT gArJdc">
                <form className="sc-eXNvrr cfoAuu">
                    {props.children}
                </form>
            </section>
        </div>
    );
}